var React = require('react');

function CloseIconInform (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M13 1L1 13","stroke":"white","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M13 13L1 1","stroke":"white","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

CloseIconInform.defaultProps = {"viewBox":"0 0 14 14"};

module.exports = CloseIconInform;

CloseIconInform.default = CloseIconInform;
